import Limit from './Limit.js'
import Map from './Map.js'
import Pipeline from './Pipeline.js'
import Deferred from './Deferred.js'

export default {
  all : Limit.all,
  limit : Limit.limit,
  map : Map.map,
  mapLimit : Map.mapLimit,
  deferred : Deferred.deferred,
  pipeline : Pipeline.pipeline
}
